export default __webpack_public_path__ + "static/pp-17b6c899c94566a120f102355853b90a.png";